<template>
  <v-dialog v-model="dialog" persistent max-width="640" :fullscreen="$vuetify.breakpoint.xsOnly"
    content-class="add-time-dialog">
    <template v-slot:activator="{ on, attrs }">
      <!-- <v-btn fab small dark color="primary" v-bind="attrs" v-on="on">
            <v-icon>mdi-plus</v-icon>
          </v-btn> -->
      <v-btn rounded v-if="appbar" small class="add-time-toolbar-button"
        v-bind="attrs" v-on="on" outlined>
        <v-icon left small>mdi-plus</v-icon>
        <span>Add time</span>
      </v-btn>
      <v-btn rounded v-else small dark v-bind="attrs" v-on="on" color="primary">ADD TIME</v-btn>

    </template>

    <v-card class="add-time-card">
      <header class="add-time-header">
        <span class="add-time-header__icon"><v-icon>mdi-clock-plus-outline</v-icon></span>
        <div>
          <small>Manual time entry</small>
          <h2>Add employee time</h2>
          <p>Enter the exact clock-in and clock-out date and time.</p>
        </div>
        <v-btn class="add-time-close" icon :disabled="loading" @click="close" aria-label="Close add time">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </header>

      <div class="add-time-body">
        <section class="add-time-section">
          <div class="add-time-section__heading">
            <span>1</span>
            <div><strong>Choose employee</strong><small>Select the employee who worked this shift.</small></div>
          </div>
          <v-autocomplete class="employee-picker" label="Search or select employee" :items="employees"
            v-model="selectedEmployee" item-text="name" return-object outlined clearable
            prepend-inner-icon="mdi-account-search-outline" :loading="employees.length === 0"
            no-data-text="No employees found"></v-autocomplete>
        </section>

        <section class="add-time-section">
          <div class="add-time-section__heading">
            <span>2</span>
            <div><strong>Enter shift time</strong><small>Type directly into each field or use the calendar icon.</small></div>
          </div>

          <div class="time-entry-grid">
            <div class="time-entry-card is-in">
              <div class="time-entry-label">
                <span><v-icon small>mdi-login</v-icon>Clock in</span>
                <small>Shift start</small>
              </div>
              <v-text-field type="datetime-local" outlined
                :value="localDateTimeValue(timeClock.clockInTime)"
                @input="updateTime('clockInTime', $event)"
                :error="Boolean(timeError)" hide-details
                aria-label="Clock in date and time"></v-text-field>
              <small class="input-format-hint">MM/DD/YYYY · HH:MM</small>
            </div>

            <div class="time-entry-arrow"><v-icon>mdi-arrow-right</v-icon></div>

            <div class="time-entry-card is-out">
              <div class="time-entry-label">
                <span><v-icon small>mdi-logout</v-icon>Clock out</span>
                <small>Shift end</small>
              </div>
              <v-text-field type="datetime-local" outlined
                :value="localDateTimeValue(timeClock.clockOutTime)"
                @input="updateTime('clockOutTime', $event)"
                :error="Boolean(timeError)" hide-details
                aria-label="Clock out date and time"></v-text-field>
              <small class="input-format-hint">MM/DD/YYYY · HH:MM</small>
            </div>
          </div>

          <div v-if="timeError" class="time-entry-message is-error">
            <v-icon small>mdi-alert-circle-outline</v-icon>{{ timeError }}
          </div>
          <div v-else class="time-entry-message is-valid">
            <v-icon small>mdi-clock-check-outline</v-icon>
            <span>Shift duration</span><strong>{{ secondsToHms(totalSeconds) }}</strong>
          </div>
        </section>

        <div class="manual-entry-note">
          <v-icon>mdi-information-outline</v-icon>
          <span>Manual entries are added as a completed shift and will appear in reports immediately.</span>
        </div>
      </div>

      <footer class="add-time-actions">
        <v-btn text large :disabled="loading" @click="close">Cancel</v-btn>
        <v-btn color="primary" rounded large :disabled="!canSubmit" :loading="loading" @click="submit">
          <v-icon left>mdi-content-save-outline</v-icon>Save time entry
        </v-btn>
      </footer>
    </v-card>
  </v-dialog>
</template>

<script>
import timeClockService from "@/modules/TimeClock/service";
import employeeService from "@/modules/Employee/service";

export default {
  props: ["employee", "appbar"],
  data: (vm) => ({
    selectedEmployee: null,
    dialog: false,
    loading: false,
    totalSeconds: 0,
    employees: [],
    timeClock: {
      clockInTime: vm.$moment().subtract(1, "hour"),
      clockOutTime: vm.$moment(),
      status: "clockedOut",
    },
  }),
  computed: {
    timeError() {
      const clockIn = new Date(this.timeClock.clockInTime);
      const clockOut = new Date(this.timeClock.clockOutTime);
      if (Number.isNaN(clockIn.getTime()) || Number.isNaN(clockOut.getTime())) {
        return "Enter both the clock-in and clock-out date and time.";
      }
      if (clockOut <= clockIn) {
        return "Clock-out must be later than clock-in.";
      }
      return "";
    },
    canSubmit() {
      return Boolean(this.selectedEmployee && !this.timeError && !this.loading);
    },
  },
  watch: {
    timeClock: {
      handler(val) {
        const date1 = new Date(val.clockInTime);
        const date2 = new Date(val.clockOutTime);
        this.totalSeconds =
          !Number.isNaN(date1.getTime()) &&
          !Number.isNaN(date2.getTime()) &&
          date2 > date1
            ? (date2 - date1) / 1000
            : 0;
      },
      deep: true,
    },
    dialog(val) {
      if (val) {
        // this.timeClock.EmployeeId = this.employee.id;
        // this.timeClock.LocationId =
        //   this.employee.LocationEmployees[0].LocationId;
        // this.timeClock.OrganizationId = this.employee.OrganizationId;
        // this.timeClock.status = "clockedOut";
        this.loadEmployees();
      }
      console.log("watch", this.employee, this.timeClock);
    },
  },
  methods: {
    localDateTimeValue(value) {
      if (!value) return "";
      return this.$moment(value).format("YYYY-MM-DDTHH:mm");
    },
    updateTime(field, value) {
      this.timeClock[field] = value
        ? this.$moment(value, "YYYY-MM-DDTHH:mm").toISOString()
        : null;
    },
    loadEmployees() {
      employeeService
        .getAll({
          limit: 100,
        })
        .then((response) => {
          console.log("response", response);
          this.employees = response.data;
          if (this.employee) {
            this.employees.map((row) => {
              if (row.id === this.employee.id) this.selectedEmployee = row;
            });
          }

          // const selectedEmployee = this.employees.filter(employee => employee.id = this.employee.id)
          console.log("empllddf", this.selectedEmployee);
        })
        .catch((error) => {
          throw error;
        });
    },
    reset() {
      this.timeClock = {
        clockInTime: this.$moment().subtract(1, "hour"),
        clockOutTime: this.$moment(),
        status: "clockedOut",
      };
    },
    close() {
      if (this.loading) return;
      this.reset();
      this.dialog = false;
    },
    secondsToHms(d) {
      d = Number(d);
      var h = Math.floor(d / 3600);
      var m = Math.floor((d % 3600) / 60);
      var s = Math.floor((d % 3600) % 60);

      var hDisplay = h > 0 ? h + (h == 1 ? " hour, " : " hours, ") : "";
      var mDisplay = m > 0 ? m + (m == 1 ? " minute, " : " minutes, ") : "";
      var sDisplay = s > 0 ? s + (s == 1 ? " second" : " seconds") : "";
      return hDisplay + mDisplay + sDisplay;
    },
    submit() {
      if (!this.canSubmit) return;
      this.loading = true;
      this.timeClock.EmployeeId = this.selectedEmployee.id;

      timeClockService
        .create(this.timeClock)
        .then(() => {
          this.dialog = false;
          this.$emit("submit");
          this.loading = false;
        })
        .catch((err) => {
          this.$emit("error", err);
          this.loading = false;
          // console.log("err :: ", err);
        });
    },
  },
};
</script>

<style scoped>
.add-time-toolbar-button {
  border-color: var(--v-border-base) !important;
  color: var(--v-textPrimary-base) !important;
  font-weight: 750;
  letter-spacing: 0;
  margin-left: 4px;
  text-transform: none;
}

.add-time-toolbar-button .v-icon {
  color: var(--v-primary-base) !important;
}

.theme--dark .add-time-toolbar-button {
  background: rgba(96, 165, 250, 0.07) !important;
}

.theme--light .add-time-toolbar-button {
  background: #f5f8fc !important;
  border-color: #cbd8e8 !important;
  color: #172235 !important;
}

.add-time-card {
  background: var(--v-background-base) !important;
  border: 1px solid var(--v-border-base);
  border-radius: 22px !important;
  color: var(--v-textPrimary-base);
  overflow: hidden;
}

.add-time-header {
  align-items: center;
  background: var(--v-surface-base);
  border-bottom: 1px solid var(--v-border-base);
  display: flex;
  gap: 13px;
  padding: 18px 20px;
}

.add-time-header__icon {
  align-items: center;
  background: rgba(96, 165, 250, 0.12);
  border: 1px solid rgba(96, 165, 250, 0.24);
  border-radius: 14px;
  display: flex;
  flex: 0 0 46px;
  height: 46px;
  justify-content: center;
}

.add-time-header__icon .v-icon {
  color: var(--v-primary-base);
}

.add-time-header small {
  color: var(--v-textSecondary-base);
  font-size: 0.62rem;
  font-weight: 800;
  letter-spacing: 0.1em;
  text-transform: uppercase;
}

.add-time-header h2 {
  font-size: 1.2rem;
  line-height: 1.25;
  margin: 1px 0 2px;
}

.add-time-header p {
  color: var(--v-textSecondary-base);
  font-size: 0.7rem;
  margin: 0;
}

.add-time-close {
  background: var(--v-surfaceMuted-base);
  color: var(--v-textPrimary-base);
  margin-left: auto;
}

.add-time-body {
  max-height: calc(88vh - 145px);
  overflow: auto;
  padding: 16px;
}

.add-time-section {
  background: var(--v-surface-base);
  border: 1px solid var(--v-border-base);
  border-radius: 16px;
  margin-bottom: 11px;
  padding: 15px;
}

.add-time-section__heading {
  align-items: center;
  display: flex;
  gap: 10px;
  margin-bottom: 14px;
}

.add-time-section__heading > span {
  align-items: center;
  background: rgba(96, 165, 250, 0.13);
  border-radius: 10px;
  color: var(--v-primary-base);
  display: flex;
  flex: 0 0 32px;
  font-size: 0.76rem;
  font-weight: 800;
  height: 32px;
  justify-content: center;
}

.add-time-section__heading strong,
.add-time-section__heading small {
  display: block;
}

.add-time-section__heading strong {
  font-size: 0.86rem;
}

.add-time-section__heading small {
  color: var(--v-textSecondary-base);
  font-size: 0.68rem;
  margin-top: 2px;
}

.employee-picker {
  margin-bottom: -20px;
}

.employee-picker ::v-deep .v-input__slot,
.time-entry-card ::v-deep .v-input__slot {
  background: var(--v-surfaceMuted-base) !important;
}

.time-entry-grid {
  align-items: center;
  display: grid;
  gap: 8px;
  grid-template-columns: minmax(0, 1fr) 30px minmax(0, 1fr);
}

.time-entry-card {
  background: var(--v-surfaceMuted-base);
  border: 1px solid var(--v-border-base);
  border-radius: 14px;
  padding: 12px;
}

.time-entry-card.is-in {
  border-top: 3px solid var(--v-success-base);
}

.time-entry-card.is-out {
  border-top: 3px solid var(--v-error-base);
}

.time-entry-label {
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}

.time-entry-label > span {
  align-items: center;
  display: flex;
  font-size: 0.76rem;
  font-weight: 800;
  gap: 4px;
}

.time-entry-card.is-in .time-entry-label > span,
.time-entry-card.is-in .time-entry-label .v-icon {
  color: var(--v-success-base);
}

.time-entry-card.is-out .time-entry-label > span,
.time-entry-card.is-out .time-entry-label .v-icon {
  color: var(--v-error-base);
}

.time-entry-label small,
.input-format-hint {
  color: var(--v-textSecondary-base);
  font-size: 0.62rem;
}

.time-entry-card ::v-deep input {
  color: var(--v-textPrimary-base) !important;
  font-size: 0.76rem;
}

.input-format-hint {
  display: block;
  margin-top: 6px;
}

.time-entry-arrow {
  align-items: center;
  display: flex;
  justify-content: center;
}

.time-entry-arrow .v-icon {
  color: var(--v-textSecondary-base);
}

.time-entry-message {
  align-items: center;
  border-radius: 12px;
  display: flex;
  font-size: 0.7rem;
  gap: 6px;
  margin-top: 10px;
  padding: 10px 12px;
}

.time-entry-message.is-error {
  background: rgba(244, 83, 94, 0.11);
  color: #f36b75;
}

.time-entry-message.is-valid {
  background: rgba(45, 190, 126, 0.11);
  color: #31c989;
}

.time-entry-message .v-icon {
  color: inherit;
}

.time-entry-message strong {
  margin-left: auto;
}

.manual-entry-note {
  align-items: center;
  background: rgba(96, 165, 250, 0.09);
  border: 1px solid rgba(96, 165, 250, 0.18);
  border-radius: 13px;
  color: var(--v-textSecondary-base);
  display: flex;
  font-size: 0.67rem;
  gap: 8px;
  padding: 11px 13px;
}

.manual-entry-note .v-icon {
  color: var(--v-primary-base);
}

.add-time-actions {
  align-items: center;
  background: var(--v-surface-base);
  border-top: 1px solid var(--v-border-base);
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  padding: 12px 18px;
}

.add-time-actions .v-btn {
  font-weight: 750;
  letter-spacing: 0;
  text-transform: none;
}

@media (max-width: 430px) {
  .add-time-toolbar-button {
    min-width: 40px !important;
    padding: 0 10px !important;
  }

  .add-time-toolbar-button span {
    display: none;
  }

  .add-time-toolbar-button .v-icon {
    margin: 0 !important;
  }
}

@media (max-width: 600px) {
  .add-time-card {
    border: 0;
    border-radius: 0 !important;
    display: flex;
    flex-direction: column;
    min-height: 100vh;
  }

  .add-time-header {
    align-items: flex-start;
    padding: 18px 16px;
  }

  .add-time-header__icon {
    display: flex;
    flex-basis: 42px;
    height: 42px;
  }

  .add-time-header h2 {
    font-size: 1.18rem;
  }

  .add-time-header p {
    display: block;
    max-width: 250px;
  }

  .add-time-body {
    flex: 1;
    max-height: none;
    overflow-y: auto;
    padding: 18px 16px 104px;
  }

  .add-time-section {
    background: transparent;
    border: 0;
    border-radius: 0;
    margin: 0 0 22px;
    padding: 0;
  }

  .add-time-section__heading {
    margin-bottom: 12px;
  }

  .add-time-section__heading > span {
    flex-basis: 30px;
    height: 30px;
  }

  .employee-picker {
    margin-bottom: -18px;
  }

  .time-entry-grid {
    grid-template-columns: 1fr;
  }

  .time-entry-arrow {
    height: 18px;
    transform: rotate(90deg);
  }

  .time-entry-card {
    padding: 14px;
  }

  .manual-entry-note {
    margin-top: 2px;
  }

  .add-time-actions {
    box-shadow: 0 -10px 30px rgba(4, 15, 30, 0.08);
    bottom: 0;
    left: 0;
    padding: 12px 16px max(12px, env(safe-area-inset-bottom));
    position: fixed;
    right: 0;
    z-index: 4;
  }

  .add-time-actions .v-btn:last-child {
    flex: 1;
    max-width: 240px;
  }
}
</style>

<style>
.add-time-dialog {
  border-radius: 22px !important;
  overflow: hidden;
}

@media (max-width: 600px) {
  .add-time-dialog {
    border-radius: 0 !important;
  }
}
</style>
